import {
  getQueryLabel,
  getLawyerName,
  getEnterpriseName,
} from './autocompleteUtils';
import {
  AutocompleteItemType,
  QueryItemType,
  EnterpriseItemType,
  LawyerItemType,
} from './searchAutocomplete.types';

const query1: Omit<QueryItemType, 'label'> = {
  type: 'query',
  suggestion: 'actif indivis "compte bancaire" époux',
};

const query2: Omit<QueryItemType, 'label'> = {
  type: 'query',
  suggestion: 'article L 311-37 Code de la consommation remboursement',
};

const lawyerItem: Omit<LawyerItemType, 'label'> = {
  suggestion: 'henri leclerc',
  metadata: {
    firstname: 'Henri',
    lawyer_id: 'LE6D87578CEA61008029A',
    lastname: 'LECLERC',
  },
  type: 'lawyer',
};

const enterpriseItem: Omit<EnterpriseItemType, 'label'> = {
  type: 'enterprise',
  suggestion: 'BNP PARIBAS',
  metadata: {
    commercial_name: 'HELLO BANK!',
    corporate_name: 'BNP PARIBAS',
    enterprise_id: 'ENT80F8692C63A719FF43BB',
    enterprise_city: '',
    enterprise_size: '',
  },
};

export const autocompleteDemoItems: AutocompleteItemType[] = [
  { ...query1, label: getQueryLabel(query1) },
  { ...query2, label: getQueryLabel(query2) },
  { ...lawyerItem, label: getLawyerName(lawyerItem) },
  { ...enterpriseItem, label: getEnterpriseName(enterpriseItem) },
];
